import type { auth as pt } from '../pt-BR/auth';
import type { Traducao } from '../Traducao';

export const auth = {
  loginTitle: 'Iniciar sesión',
  loginSubtitle: 'Inicia sesión en tu cuenta para continuar.',
  tagline: 'Tu plataforma de backoffice.',
  email: 'Correo electrónico',
  password: 'Contraseña',
  submit: 'Iniciar sesión',
  passwordShow: 'Mostrar contraseña',
  passwordHide: 'Ocultar contraseña',
  azureSignIn: 'Iniciar sesión con Microsoft',
  orContinueWith: 'o continúa con correo',
  invalidCredentials: 'Correo o contraseña no válidos.',
  azureCallbackPending: 'Finalizando inicio de sesión con Microsoft...',
  azureCallbackFailed: 'No se pudo completar el inicio de sesión. Inténtalo de nuevo.',
  logout: 'Cerrar sesión',
  avisoEmailNt: {
    titulo: 'Use su correo de NTConsult',
    texto:
      'Ingrese con el correo @ntconsult.com.br o @ntconsultcorp.com. No use el correo del cliente donde trabaja, aunque sea de Microsoft.',
    dica: 'Use el correo de NTConsult (@ntconsult.com.br o @ntconsultcorp.com).',
  },
} as const satisfies Traducao<typeof pt>;
